import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ESiteAccessAvailability = {
	all: 'All',
	yes: 'Yes',
	no: 'No',
} as const;

export type TSiteAccessAvailability = TValueOfStringRecord<typeof ESiteAccessAvailability>

